import React from "react";
import styled from "styled-components";
import { Theme, colors } from "@literati/public-ui-shared-react";
import { PlanPrepaid } from "components/PlanSelection/planSelectionTypes";
import { PlanPrepaidPricing } from "components/PlanSelection/planSelectionUtil";

const CLASS_BASE = "plan-selection-prepaid-promo";
export const PlanSelectionPrepaidPromoClassName = {
  BASE: CLASS_BASE,
} as const;

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const TextPeriwinkle = styled.span`
  font-size: 1.25rem;
  font-weight: 800;
  color: ${colors.periwinkleShade1};
`;

const TextGray = styled.span`
  font-style: italic;
  color: ${colors.warmGray2};
`;

export interface PlanSelectionPrepaidPromoProps {
  className?: string;
  plan: PlanPrepaid;
  planPrepaidPricing: PlanPrepaidPricing;
}

export const PlanSelectionPrepaidPromo = ({
  className = "",
  plan,
  planPrepaidPricing,
}: PlanSelectionPrepaidPromoProps) => {
  const cls = PlanSelectionPrepaidPromoClassName;

  const { basePriceCurrencyString } = planPrepaidPricing;
  const boxCount = plan?.boxCount;
  const boxCopy =
    boxCount === 1 ? (
      <>
        <strong>One box monthly</strong> with 3 books
      </>
    ) : (
      `${boxCount} boxes with 3 books each`
    );

  return (
    <Theme>
      <StyledDiv className={`${cls.BASE} ${className}`}>
        <div
          css={`
            font-size: 0.875rem;
            text-align: center;
          `}
        >
          <p css="font-weight: 500">{boxCopy}</p>
          <p>
            <TextPeriwinkle>
              {plan?.costPerBox}
              <span css="font-size: 0.75rem">/box</span>
            </TextPeriwinkle>
          </p>
          {boxCount !== 1 ? (
            <p css="line-height: 0.875rem">
              <TextGray>cart price: {basePriceCurrencyString}</TextGray>
            </p>
          ) : null}
        </div>
      </StyledDiv>
    </Theme>
  );
};

export default PlanSelectionPrepaidPromo;
